<template>
  <div class="promo-gallery">
    <DefSwiper :settings="settings" :time-line="true">
      <SwiperSlide v-for="({ id, link, picture, video, animation }, key) in result.items" :key="id">
        <a v-if="video" :href="link" class="promo-gallery__item">
          <DefImg
            v-if="isIphone"
            :result="video"
            :lazy-load="false"
            :max-size-off="screenWidth < 768"
            max-height="100vh"
            max-width="100vw"
          />
          <DefVideo v-else :result="video" :play="key === slideIndex" :lazy-load="false" />
        </a>
        <a v-else-if="animation" :href="link" class="promo-gallery__item">
          <DefImg
            :result="animation"
            :max-size-off="screenWidth < 768"
            max-height="100vh"
            max-width="100vw"
            :lazy-load="false"
          />
        </a>
        <a v-else :href="link" class="promo-gallery__item">
          <DefImg
            :result="picture"
            :max-size-off="screenWidth < 768"
            max-height="100vh"
            max-width="100vw"
            :lazy-load="false"
          />
        </a>
      </SwiperSlide>
    </DefSwiper>
  </div>
</template>

<script lang="ts" setup>
import DefSwiper from '@components/Def/DefSwiper/DefSwiper.vue';
import { SwiperSlide } from 'swiper/vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { EffectCube, Navigation, Pagination, Autoplay } from 'swiper/modules';
import { getScrollbarWidth } from '@/utils/helpers';
import { ref } from 'vue';
import { IPromoSliderResult } from '@components/Promo/PromoSlider/IPromoSlider';
import DefVideo from '@components/Def/DefVideo/DefVideo.vue';
import { screenWidth, isIphone } from '@use/useDeviceInfo';

const scrollbarWidth = ref(`${getScrollbarWidth()}px`);

const props = defineProps<{ result: IPromoSliderResult; slideNumber: number }>();

const slideIndex = ref(0);

const settings: SwiperOptions = {
  //  Autoplay
  modules: [Navigation, Pagination, EffectCube, Autoplay],
  effect: 'cube',
  grabCursor: true,
  speed: 1000,
  // slidesPerView: 'auto',
  slidesPerView: 1,
  loop: true,
  autoplay: { delay: 7000, disableOnInteraction: false },
  cubeEffect: {
    // !important off shadow fix bag for IOS
    shadow: false,
    slideShadows: false,
  },
  // allowTouchMove: false,
  initialSlide: props.slideNumber,
  onSlideChange: ({ realIndex }) => {
    slideIndex.value = realIndex;
  },
  // slideVisibleClass: '',
};
</script>

<style lang="scss" scoped>
.promo-gallery {
  overflow: hidden;
  :deep(.def-swiper) {
    display: flex;
    align-items: center;
    width: calc(100vw - v-bind(scrollbarWidth));
    height: 100vh;
  }
  :deep(.swiper) {
    width: calc(100vw - v-bind(scrollbarWidth));
    height: 100vh;
    //@supports (-webkit-touch-callout: none) {
    /* CSS specific to iOS devices */
    //background-color: var(--background-black);
    //}
  }
  :deep(.swiper-wrapper) {
    width: 100%;
    height: 100%;
  }
  :deep(.swiper-slide) {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--background-black);
  }
  &__item {
    display: block;
    max-height: 100%;
    overflow: hidden;
  }
  &__img {
    max-width: 100%;
  }
  :deep(.def-swiper-button-prev) {
    background-color: rgba(184, 217, 236, 0.6);
    transform: unset;
    left: 24px;
  }
  :deep(.def-swiper-button-next) {
    background-color: rgba(184, 217, 236, 0.6);
    transform: unset;
    right: 24px;
  }
  :deep(.swiper-pagination) {
    position: absolute;
    bottom: 24px;
    margin: 0;
  }
}
</style>
